
import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const YoutubeIconSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0776 1.78339C13.9999 1.49062 13.8468 1.22334 13.6336 1.00822C13.4203 0.793095 13.1544 0.637646 12.8623 0.557378C11.7962 0.269531 7.49982 0.269531 7.49982 0.269531C7.49982 0.269531 3.20345 0.269531 2.13202 0.557378C1.83994 0.637646 1.574 0.793095 1.36075 1.00822C1.1475 1.22334 0.994379 1.49062 0.916665 1.78339C0.721733 2.88126 0.62717 3.9946 0.634149 5.10962C0.62717 6.22464 0.721733 7.33797 0.916665 8.43584C0.993562 8.7296 1.14632 8.99798 1.35962 9.21409C1.57293 9.4302 1.83929 9.58646 2.13202 9.66719C3.19811 9.95503 7.49982 9.95503 7.49982 9.95503C7.49982 9.95503 11.7909 9.95503 12.8623 9.66719C13.1537 9.58738 13.4192 9.43274 13.6324 9.2186C13.8456 9.00447 13.9991 8.73829 14.0776 8.4465C14.2762 7.34905 14.3726 6.23553 14.3655 5.12028C14.3733 4.00146 14.2769 2.88435 14.0776 1.78339ZM6.08191 7.15119V3.06804L9.67466 5.10962L6.08191 7.15119Z"
      fill="currentColor"
    />
  </svg>
);

export const YoutubeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={YoutubeIconSvg} {...props} />
);
